import { Box } from "@chakra-ui/react";
import CopyableValue, {
  Props as BaseProps,
} from "components/Shared/CopyableValue";

export function renderValue(value: string) {
  return (
    <Box
      as="code"
      opacity={0.8}
      fontSize=".95em"
      fontWeight="normal"
      isTruncated
    >
      {value}
    </Box>
  );
}

type Props = Omit<BaseProps, "value"> & {
  code: string;
};

export default function CopyableCode({ code, ...rest }: Props) {
  return <CopyableValue renderValue={renderValue} value={code} {...rest} />;
}
